import { makeReadContract, makeReadContracts } from '@/utils/wagmi/makeOperations'
import { abi } from '@/abi/SurveyFactory'
import { useSurveyFactoryContractAddress } from './useSurveyFactoryContract'

export const useReadSurveyFactory = makeReadContract(abi, useSurveyFactoryContractAddress)

/*
 * Fetches multiple methods from the SurveyFactory contract
 * @returns A hook to fetch multiple methods from the SurveyFactory contract
 */
export const useReadSurveyFactoryMulti = makeReadContracts(abi, useSurveyFactoryContractAddress)
